import * as React from "react";
import type { SVGProps } from "react";
const SvgWellness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#wellness_svg__a)">
      <path d="M15 20h-3a1 1 0 0 1-1-1v-2a7 7 0 0 1 7-7h3a1 1 0 0 1 1 1v2a7 7 0 0 1-7 7m-2-2h2a5 5 0 0 0 5-5v-1h-2a5 5 0 0 0-5 5z" />
      <path d="M12 20H9a7 7 0 0 1-7-7v-2a1 1 0 0 1 1-1h3a7 7 0 0 1 7 7v2a1 1 0 0 1-1 1m-8-8v1a5 5 0 0 0 5 5h2v-1a5 5 0 0 0-5-5z" />
      <path d="M7.57 12h-.14a1 1 0 0 1-.85-1.13l.08-.55a6.92 6.92 0 0 1 2.73-4.61l2-1.51a1 1 0 0 1 1.2 0l2 1.51a6.92 6.92 0 0 1 2.73 4.61l.08.54a1.01 1.01 0 1 1-2 .28l-.08-.54a5 5 0 0 0-1.95-3.29L12 6.25l-1.41 1.06a5 5 0 0 0-1.95 3.29l-.08.55a1 1 0 0 1-.99.85" />
    </g>
    <defs>
      <clipPath id="wellness_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWellness;
